import { useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    Box,
    Alert,
} from "@mui/material";
import { post } from "src/utils/networkUtils";
import { PlayerStatTypes } from "src/constants/playerStatTypes";

export default function AddTrainingDialog({ open, onClose, cardId, onSuccess }) {
    const [trainingType, setTrainingType] = useState("");
    const [count, setCount] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const handleClose = () => {
        setTrainingType("");
        setCount("");
        setError("");
        onClose();
    };

    const handleSubmit = async () => {
        setError("");

        // Validation
        if (trainingType === "") {
            setError("Please select a training type");
            return;
        }
        if (!count || count < 1 || count > 15) {
            setError("Count must be between 1 and 15");
            return;
        }

        setLoading(true);

        try {
            await post(`/admin/training/add-trainings/${cardId}`, {
                trainingType: parseInt(trainingType),
                count: parseInt(count),
            });

            setLoading(false);
            handleClose();
            if (onSuccess) {
                onSuccess();
            }
        } catch (err) {
            setLoading(false);
            setError(err?.response?.data?.error || "Failed to add training");
        }
    };

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
            <DialogTitle>Add Training to Card #{cardId}</DialogTitle>
            <DialogContent>
                <Box sx={{ mt: 2, display: "flex", flexDirection: "column", gap: 2 }}>
                    {error && (
                        <Alert severity="error" onClose={() => setError("")}>
                            {error}
                        </Alert>
                    )}

                    <FormControl fullWidth>
                        <InputLabel id="training-type-label">Training Type</InputLabel>
                        <Select
                            labelId="training-type-label"
                            value={trainingType}
                            label="Training Type"
                            onChange={(e) => setTrainingType(e.target.value)}
                        >
                            {Object.entries(PlayerStatTypes).map(([key, value]) => (
                                <MenuItem key={key} value={key}>
                                    {value}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    <TextField
                        label="Number of Trainings"
                        type="number"
                        fullWidth
                        value={count}
                        onChange={(e) => setCount(e.target.value)}
                        inputProps={{ min: 1, max: 15 }}
                        helperText="Enter a number between 1 and 15"
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} disabled={loading}>
                    Cancel
                </Button>
                <Button onClick={handleSubmit} variant="contained" disabled={loading}>
                    {loading ? "Adding..." : "Add Training"}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
